/**
 * A click guard for sends to Epic (z8nrz7fdc1 AC7): one request per click while
 * one is in flight.
 *
 * Disabling the button on `isPending` is not enough on its own: two clicks can
 * land before React re-renders with the disabled state, and both would send. A
 * ref flips synchronously, inside the first click.
 */
export interface InFlightLock {
  current: boolean
}

/** True for the click that may send, false while a send it started is still in flight. */
export function tryClaim(lock: InFlightLock): boolean {
  if (lock.current) return false
  lock.current = true
  return true
}

/** Lets the next click send; call it once the request settles, success or not. */
export function releaseClaim(lock: InFlightLock): void {
  lock.current = false
}
